<template>
  <v-row>
    <v-col cols="12" sm="12" md="12" lg="12" xl="12">
      <TitleAndSearch
        :icon="'icon_create_report'"
        :title="'Generación de Informe'"
        :showSearch="true"
      />
      

      <CreateReport />
      

    </v-col>
  </v-row>
</template>

<script>
import CreateReport from "@/components/createReport/CreateReport.vue"
import TitleAndSearch from '@/components/TitleAndSearch.vue'
import TrailForm from '@/components/createReport/TrailForm.vue'

export default {
  name: 'CreateReportView',
  components: {
    CreateReport,
    TitleAndSearch,
    TrailForm
  }
}
</script>

<style lang="scss" scoped></style>
